import { render } from "./IconNoData.vue?vue&type=template&id=0cf473ca&ts=true"
import script from "./IconNoData.vue?vue&type=script&lang=ts"
export * from "./IconNoData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__